import Vue from 'vue';
import App from './App';

import router from './router';
import store from './stores';

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue(); // Global event bus

new Vue({
    el: '#app',

    router,
    store,

    render: h => h(App),
});
